import React, { useState, useEffect } from 'react'
import NoListEditor from '../Helpers/Utilities/NoListEditor.js';
import UserAvatar from '../Avatar/UserAvatar.js'
import { HTTP } from '../../api/resources'

const currentDomain = window.location.host;
const wss = new WebSocket(`wss://${currentDomain}/cable`);

export default function ChatRoom(props) {
  const members = props.members
  const [messages, setMessages] = useState([])
  const [message, setMessage] = useState(null)
  const [editingMessage, setEditingMessage] = useState(false)
  const [editedMessage, setEditedMessage] = useState(null)
  const [guid, setGuid] = useState("");
  const [permittedUser, setPermittedUser] = useState(true)
  const [saving, setSaving] = useState(false)
  const community = props.community
  const [deletingMessage, setDeletingMessage] = useState(false)
  const user = props.user
  const messagesContainer = document.getElementById("messages");
  let isManager = user.user_type == 'manager' || user.user_type == 'assistant_manager'

  wss.onopen = () => {
    setGuid(Math.random().toString(36).substring(2, 15));

    wss.send(
      JSON.stringify({
        command: "subscribe",
        identifier: JSON.stringify({
          id: guid,
          channel: 'MessageChannel',
        }),
      })
    );
  };

  wss.onmessage = (e) => {
    const data = JSON.parse(e.data);
    if (data.type === "ping") return;
    if (data.type === "welcome") return;
    if (data.type === "confirm_subscription") return;
    const message = data.message;
    if (message.team_page_id !== community.id) return

    if (message.editing) {
      updateMessageContent(message.id, message.likes, message.content)
      setMessage('')
      setEditingMessage(false)
      setEditedMessage(null)
      return
    }

    if (message.destroy) {
      removeMessage(message.id)
      setDeletingMessage(false)
      return
    }

    setMessagesAndScrollDown([...messages, message]);
  };

  const determinePermission = () => {
    let isUser = user.user_type !== 'donor' && user.user_type !== 'beneficiary' && !isManager

    if (isManager) return true

    if (community.admin_only_messaging && isManager) return true

    if (community.donor_messaging && (user.user_type == 'donor' || isManager)) return true

    if (community.beneficiary_messaging && (user.user_type == 'beneficiary' || isManager)) return true

    if (community.user_messaging && (isUser || isManager)) return true

    return false
  }

  useEffect(() => {
    setPermittedUser(determinePermission())
    fetchMessages();
  }, []);

  useEffect(() => {
    resetScroll();
  }, [messages]);

  const handleSubmit = async () => {
    setSaving(true)
    let data = {
      message: message
    }

    try {
      await createRoute(data)
    } catch {
      Alert.show('error', 'Could not send message, try again')
      setSaving(false)
      return
    }

    setMessage('')
    setSaving(false)
  }

  useEffect(() => {}, [message])

  const createRoute = (data) => {
    return HTTP.post(`/user/messages/${community.id}/${user.id}`, data)
  }

  const fetchMessages = async () => {
    const response = await fetch(`/users/messages/${community.id}`);
    const data = await response.json();
    setMessagesAndScrollDown(data);
  };

  const setMessagesAndScrollDown = (data) => {
    setMessages(data);
    resetScroll();
  };

  const resetScroll = () => {
    if (!messagesContainer) return;
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  };

  const removeMessage = (id) => {
    const updatedMessages = messages.filter((message) => message.id !== id);
    setMessages(updatedMessages);
  };

  const updateMessageContent = (id, likes, content) => {
    const updatedMessages = messages.map((message) =>
      message.id === id ? { ...message, content: content, likes: likes } : message
    );
    setMessages(updatedMessages);
  };

  const handleDelete = async (msg) => {
    setDeletingMessage(true)

    try {
      await deleteRoute(msg.id)
    } catch {
      Alert.show('error', 'Could not delete message, try again')
      return
    }

    Alert.show('notice', 'Message delete successfully')
  }

  const deleteRoute = (id) => {
    return HTTP.delete(`/user/messages/${id}`)
  }

  const handleManageSubmition = () => {
    if (editingMessage) {
      handleUpdate(editedMessage, false)
      return
    }

    handleSubmit()
  }

  const handleUpdate = async (msg, liked) => {
    setSaving(true)
    let data = {
      content: msg.content,
      likes: msg.likes
    }

    if (editingMessage) data.content = message

    if (liked) data.likes += 1

    try {
      await likeRoute(msg.id, data)
    } catch {
      Alert.show('error', 'Could not perform action')
      setSaving(false)
      return
    }

    setSaving(false)
  }

  const likeRoute = (id, data) => {
    return HTTP.patch(`/user/messages/${id}`, data)
  }

  const type = (userType) => {
    let name = userType.replace('_', ' ')
    return name
  }

  return (
    <div>
      <div className='card'>
        <div className='card-header'>
          <h4>{ community.title }</h4>
        </div>
        <div className='card-body'>
          <div className='room-chat-display' id="messages" >
            <ul>
              {messages.length < 1 &&
                <li className='empty-message'>
                  No messages at the moment, be the first to send a message
                </li>
              }
              {messages && messages.map(msg => (
                <>
                  {msg.sender.id !== user.id &&
                    <li key={msg.id}>
                      <div className='d-flex w-100'>
                        <UserAvatar url={ msg.sender.avatar_url } fallback={msg.sender.first_name} />
                        <div className='ml-2 w-100'>
                          <b onClick={() => window.location = `/b/${msg.sender.id}`} style={{cursor: 'pointer'}}>
                            { `${msg.sender.first_name} ${msg.sender.last_name}` }
                            <span className='badge ml-3'>{ type(msg.sender.user_type) }</span>
                          </b>
                          <div dangerouslySetInnerHTML={{ __html: msg.content }} className='message-container'>
                          </div>
                        </div>
                      </div>

                      <div className='actions-modal' style={{top: '0', right: '0'}}>
                        <span title='Like this message' onClick={() => handleUpdate(msg, true)} style={{cursor: 'pointer'}}>
                        { msg.likes } <i class="far fa-thumbs-up text-secondary-icon mr-2"></i>
                        </span>

                        {isManager &&
                          <span title='Delete this message' onClick={() => {if (window.confirm('This action cannot be reversed')) handleDelete(msg)}} style={{cursor: 'pointer'}}>
                            <i class="fas fa-trash-alt text-danger mr-2"></i>
                          </span>
                        }
                      </div>
                  </li>
                  }

                  {msg.sender.id == user.id &&
                    <li key={msg.id} className='right-msg'>
                      <div className='actions-modal' style={{top: '0', left: '0'}}>
                        <span title='Like this message' style={{cursor: 'pointer'}}>
                          { msg.likes } <i class="far fa-thumbs-up text-secondary-icon mr-2"></i>
                        </span>

                        {(isManager || user.id == msg.sender.id) &&
                          <span title='Edit this message' onClick={() => {
                            setEditingMessage(true)
                            setEditedMessage(msg)
                            setMessage(msg.content)
                          }} style={{cursor: 'pointer'}}>
                            <i class="far fa-edit text-secondary-icon ml-2"></i>
                          </span>
                        }

                        {(isManager || user.id == msg.sender.id) &&
                          <span title='Delete this message' onClick={() => {if (window.confirm('This action cannot be reversed')) handleDelete(msg)}} style={{cursor: 'pointer'}}>
                            <i class="fas fa-trash-alt text-danger ml-2"></i>
                          </span>
                        }
                      </div>

                        <div className='d-flex w-100'>
                          <div className='mr-2 w-100'>
                          <b onClick={() => window.location = `/b/${msg.sender.id}`} style={{cursor: 'pointer'}}>
                          <span className='badge mr-3'>{ type(msg.sender.user_type) }</span>
                            { `${msg.sender.first_name} ${msg.sender.last_name}` }
                          </b>
                          <div dangerouslySetInnerHTML={{ __html: msg.content }} className='message-container'>
                          </div>
                          </div>
                          <UserAvatar url={ msg.sender.avatar_url } fallback={msg.sender.first_name} />
                        </div>
                    </li>
                  }
                </>
              ))}
            </ul>
          </div>
          <div className='room-message-editor'>
            {permittedUser &&
              <NoListEditor value={message} returnChange={(value) => setMessage(value)} height={false}/>
            }

            {permittedUser &&
              <div style={{ textAlign: 'right'}}>
                <button className='btn btn-primary btn-sm mt-1' onClick={handleManageSubmition} disabled={saving}>Send <i class="far fa-paper-plane ml-1"></i></button>
              </div>
            }

            {!permittedUser &&
              <div style={{textAlign: 'center'}}>
                <b>You are not permitted to send a message</b>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}
